(() => {
  if (window.__tdSignup) return;
  window.__tdSignup = true;
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-td-signup]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.pending === 'true' || form.dataset.complete === 'true') return;
    const input = form.querySelector('input[type=email]');
    const status = form.querySelector('[role=status]');
    const button = form.querySelector('button[type=submit]');
    input.value = input.value.trim();
    if (!input.checkValidity() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value)) {
      input.setAttribute('aria-invalid', 'true');
      status.textContent = 'Enter a valid email address, such as name@example.com.';
      input.focus(); return;
    }
    input.removeAttribute('aria-invalid');
    form.dataset.pending = 'true';
    form.setAttribute('aria-busy', 'true');
    button.disabled = true; button.textContent = 'Sending…';
    status.textContent = 'Submitting your signup…';
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=YsZ48r', {
        method: 'POST', signal: controller.signal,
        headers: {'content-type': 'application/json', revision: '2024-02-15'},
        body: JSON.stringify({data: {type: 'subscription',
          attributes: {profile: {data: {type: 'profile', attributes: {email: input.value}}}},
          relationships: {list: {data: {type: 'list', id: 'UyGfLC'}}}}})
      });
      if (!response.ok) throw new Error('signup-failed');
      form.dataset.complete = 'true';
      input.value = ''; input.disabled = true;
      button.textContent = 'Signup submitted';
      status.textContent = 'Thank you. Your signup was submitted. If a confirmation email arrives, follow its link to finish joining.';
      status.focus();
      // Measurement failure must never change the signup result. No email is sent to pixels here.
      try { window.tdPrivacy?.trackLead(form.dataset.source); } catch (_) {}
    } catch (_) {
      status.textContent = 'We could not confirm your signup. Please try again, or email admin@tinydisplays.ca for help.';
      button.disabled = false; button.textContent = 'Join the waitlist';
      status.focus();
    } finally {
      clearTimeout(timer); form.dataset.pending = 'false'; form.removeAttribute('aria-busy');
    }
  });
})();
